import "typeface-roboto";
import "react-toastify/dist/ReactToastify.css";

import CssBaseline from "@material-ui/core/CssBaseline";
import React, { FunctionComponent } from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { ToastContainer } from "react-toastify";

import Routes from "./routes";
import Theme from "./theme/theme";

const App: FunctionComponent = () => {
  React.useEffect(() => {
    // @ts-ignore
    window.__lo_site_id = 325763;
    // @ts-ignore
    const wa = document.createElement("script");
    wa.type = "text/javascript";
    wa.async = true;
    wa.src = "https://d10lpsik1i8c69.cloudfront.net/w.js";
    // @ts-ignore
    const s = document.querySelectorAll("script")[0];
    // @ts-ignore
    s.parentNode.insertBefore(wa, s);
  });

  return (
    <MuiThemeProvider theme={Theme}>
      <CssBaseline />
      <ToastContainer />
      <Routes />
    </MuiThemeProvider>
  );
};

export default App;
